<h1 mat-dialog-title class="p-2 text-center">Ajout d'un soufflage</h1>
<div mat-dialog-content class="p-3">

    <div class="row">
        <mat-form-field class="col">
            <mat-label>Largeur (m)</mat-label>
            <input matInput type="number" [(ngModel)]="Model.Largeur" placeholder="Largeur (m)" (keyup)="updateSurface()">
            @if (!Model.Largeur || Model.Largeur < 1) {
              <span class="error">
                Ne peut être négatif ou nul
                </span>
                }
        </mat-form-field>
    </div>
    <div class="row">
        <mat-form-field class="col">
            <mat-label>Longueur (m)</mat-label>
            <input matInput type="number" [(ngModel)]="Model.Longueur" placeholder="Longueur (m)" (keyup)="updateSurface()">
            @if (!Model.Longueur || Model.Longueur < 1) {
                <span class="error">
                    Ne peut être négatif ou nul
                    </span>
                }
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="col">
            <mat-label>Surface (m²)</mat-label>
            <input matInput type="number" [(ngModel)]="Model.Surface" placeholder="Surface (m²)">
            @if (!Model.Surface || Model.Surface < 1) {
                <span class="error">
                    Ne peut être négatif ou nul
                    </span>
                }
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="col">
            <mat-label>Vitesse (m/s)</mat-label>
            <input matInput type="number" [(ngModel)]="Model.Vitesse" placeholder="Vitesse (m/s)">
            @if (Model.Vitesse! < 0) {
                <span class="error">
                    Ne peut être négatif
                    </span>
                }
        </mat-form-field>
    </div>

    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!canSave()">
            Valider
        </button>
    </div>
</div>